import { render, staticRenderFns } from "./ContactPhoneEmail.vue?vue&type=template&id=1db1ae95"
import script from "./ContactPhoneEmail.vue?vue&type=script&lang=js"
export * from "./ContactPhoneEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db1ae95')) {
      api.createRecord('1db1ae95', component.options)
    } else {
      api.reload('1db1ae95', component.options)
    }
    module.hot.accept("./ContactPhoneEmail.vue?vue&type=template&id=1db1ae95", function () {
      api.rerender('1db1ae95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact/ContactPhoneEmail.vue"
export default component.exports